import type { GachaMachineView } from "./gacha-data"
import packArtMap from "./gacha-pack-art-map.json"

const excludedMachineCodes: readonly string[] = packArtMap.excludedMachineCodes
const excludedMachineCodesByChain: Record<string, readonly string[]> =
  packArtMap.excludedMachineCodesByChain

export function filterGachaPurchaseMachines(
  machines: readonly GachaMachineView[],
  chain: number | "solana",
) {
  return machines.filter(
    (machine) => !isGachaMachineExcluded(machine.code, chain),
  )
}

export function isGachaMachineExcluded(
  machineCode: string,
  chain: number | "solana",
) {
  return (
    excludedMachineCodes.includes(machineCode) ||
    (excludedMachineCodesByChain[String(chain)]?.includes(machineCode) ?? false)
  )
}
